import _ from "lodash";


export function getSizes(products, filterSizes) {
    return _.filter(products, function (product) {
        let variantsFinded = _.filter(product.variants, function (variant) {
            let stockFinded = _.filter(variant.stock, function (stock) {
                return filterStock(stock, filterSizes) ? stock : null;
            });
            return _.isEmpty(stockFinded) ? null : variant;
        });
        return _.isEmpty(variantsFinded) ? null : product;
    });
}


export function filterLinesInitial(products, line){

   return _.filter(products, function (product) {
        if (product.line.toUpperCase() === line.toUpperCase()) {
            return product;
        }
    });
}


export function serviceFilter(products, filterPrice, filterSizes, filterColors, filterLines, filterCategories) {
    let productsPrices = [];
    productsPrices = _.filter(products, function (product) {
        if ((product.sale === false && product.price >= filterPrice.min && product.price <= filterPrice.max)
            || (product.sale === true && product.salePrice >= filterPrice.min && product.salePrice <= filterPrice.max)) {
            return product;
        }
    });


    if (!_.isEmpty(filterCategories)) {
        productsPrices = getCategories(productsPrices, filterCategories);
    }
    if (!_.isEmpty(filterLines)) {
        productsPrices = getLines(productsPrices, filterLines);
    }
    if (!_.isEmpty(filterColors)) {
        productsPrices = getColors(productsPrices, filterColors);
    }
    if (!_.isEmpty(filterSizes)) {
        productsPrices = getSizes(productsPrices, filterSizes);
    }
    return productsPrices;
}

function compareValues(key, order = 'asc') {
    return function innerSort(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            // property doesn't exist on either object
            return 0;
        }

        const varA = (typeof a[key] === 'string')
            ? a[key].toUpperCase() : a[key];
        const varB = (typeof b[key] === 'string')
            ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
            comparison = 1;
        } else if (varA < varB) {
            comparison = -1;
        }
        return (
            (order === 'desc') ? (comparison * -1) : comparison
        );
    };
}


export function orderByPrice(products, order) {
    let sortedArray = _.cloneDeep(products);

    return sortedArray.sort(compareValues('price', order));
}

function getLines(products, filterLines) {
    return _.filter(products, function (product) {
            let lineFinded = filterLine(product, filterLines) ? product : null;
            return _.isEmpty(lineFinded) ? null : product;

    });
}

function getCategories(products, filterCategories) {
    return _.filter(products, function (product) {
            let categoryFinded = filterCategory(product, filterCategories) ? product : null;
            return _.isEmpty(categoryFinded) ? null : product;

    });
}

function getColors(products, filterColors) {
    return _.filter(products, function (product) {
        let variantsFinded = _.filter(product.variants, function (variant) {
            return filterColor(variant, filterColors) ? variant : null;
        });
        return _.isEmpty(variantsFinded) ? null : product;
    });
}


function filterLine(product, filterLines) {
    let findedLine = false;
    filterLines.every(function (line) {
        if (product.line.toUpperCase() === line.toUpperCase()) {
            findedLine = true;
            return false
        }
        else return true
    })
    return findedLine;
}

function filterCategory(product, filterCategories) {
    let findedCategory = false;
    filterCategories.every(function (category) {
        if (product.category.toUpperCase() === category.toUpperCase()) {
            findedCategory = true;
            return false
        }
        else return true
    })
    return findedCategory;
}


function filterColor(variant, filterColors) {
    let findedColor = false;
    filterColors.every(function (color) {
        if (variant.color && color && variant.color.hex.toUpperCase() === color.toUpperCase()) {
            findedColor = true;
            return false
        }
        else return true
    })
    return findedColor;
}

function filterStock(stock, filterSizes) {
    let findedSize = false;
    filterSizes.every(function (size) {
        if (stock.size === size && stock.quantity > 0) {
            findedSize = true;
            return false
        }
        else return true
    })
    return findedSize;
}

export function filterStockByVariant(stock, size) {
    let findedSize = false;
    stock.every(function (sizeStock) {
        if (sizeStock.size === size && sizeStock.quantity > 0) {
            findedSize = true;
            return false
        }
        else return true
    })
    return findedSize;
}


export function getColorsProduct(product) {
    let variantsColors = [];
    _.forEach(product.variants, function (variant) {
        let variantColor = { color: "", idVariant: "", colorName: "", colorImage: ""};
        variantColor.colorName = variant.colorName;
        variantColor.idVariant = variant._id;
        variantColor.color = variant.color.hex;
        variantColor.colorImage = variant.colorImage.url;
        variantsColors.push(variantColor);
    });
    return variantsColors;
}